import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.component.html',
  styleUrls: ['./server-error.component.css']
})
export class ServerErrorComponent implements OnInit {

  @Input() error;
  @Input() retry;
  errorList = [];
  gotError: boolean;
  @Output() retryAction = new EventEmitter();

  constructor() { }

  ngOnInit() {
  
  if ( this.error.length != undefined ) {
    this.gotError = true;
    this.errorList = this.error.error;
   } else {
     this.gotError = false;
   }
  }

  retryReq() {
    this.retryAction.emit();


  }

}
